import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { Pos } from 'src/app/core/classes/pos';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'dq-pos-location-data',
  templateUrl: './pos-location-data.component.html',
  styleUrls: ['./pos-location-data.component.scss'],
})
export class PosLocationDataComponent implements OnInit, OnChanges {
  @ViewChild('mapContainer', { static: false })
  gmap!: ElementRef;
  map!: google.maps.Map;
  mapOptions: google.maps.MapOptions = {
    center: { lat: 43.3624580616706, lng: -8.409116864967402 },
    zoom: 18,
  };

  @Input()
  editMode: boolean = false;
  @Input()
  posSelected!: Pos;

  @Input()
  locationForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.locationForm = this.formBuilder.group({});
  }

  ngOnInit(): void {}

  fullAdrress(pos: Pos): string {
    let str = '-';
    if (pos != null && pos != undefined) {
      str = '';
      str = str + (pos.shippingStreet ? pos.shippingStreet : '');
      str = str + (pos.shippingCity ? ', ' + pos.shippingCity : '');
      str =
        str +
        ', ' +
        (pos.shippingPostalCode ? '(' + pos.shippingPostalCode + ')' : '');
      str = str + (pos.shippingState ? ', ' + pos.shippingState : ' ');
      str = str + (pos.shippingCountry ? ', ' + pos.shippingCountry : ' ');
    }
    return str;
  }
  ngAfterViewInit(): void {
    this.mapInitializer();
  }

  mapInitializer() {
    if (this.gmap != undefined) {
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

      var bounds = new google.maps.LatLngBounds();

      let lat: number = this.posSelected.lat ? this.posSelected.lat : 0;
      let lng: number = this.posSelected.lon ? this.posSelected.lon : 0;

      //add marker
      var myLatLng = new google.maps.LatLng(lat, lng);
      var marker = new google.maps.Marker({
        map: this.map,
        position: myLatLng,
      });

      this.map.setCenter(myLatLng);
    }
  }

  ngOnChanges(changes: any) {
    this.mapInitializer();
  }
}
